'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _radium = require('radium');

var _radium2 = _interopRequireDefault(_radium);

var _emojione = require('emojione');

var _emojione2 = _interopRequireDefault(_emojione);

var _htmlReactParser = require('html-react-parser');

var _htmlReactParser2 = _interopRequireDefault(_htmlReactParser);

var _map = require('lodash/map');

var _map2 = _interopRequireDefault(_map);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

var _getStyles = require('./get-styles');

var _getStyles2 = _interopRequireDefault(_getStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  category: _propTypes2.default.string.isRequired,
  emojis: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    shortname: _propTypes2.default.string.isRequired
  })).isRequired,
  sendEmoji: _propTypes2.default.func.isRequired,
  style: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  emojiStyle: _propTypes2.default.object // eslint-disable-line react/forbid-prop-types
};

var defaultProps = {
  style: {},
  emojiStyle: {}
};

var EmojiCategory = function EmojiCategory(_ref) {
  var category = _ref.category,
      emojis = _ref.emojis,
      sendEmoji = _ref.sendEmoji,
      style = _ref.style,
      emojiStyle = _ref.emojiStyle;
  return _react2.default.createElement(
    'article',
    { style: _getStyles2.default.category(style) },
    _react2.default.createElement(
      'h1',
      { style: _styles2.default.category.header },
      category
    ),
    _react2.default.createElement(
      'section',
      { style: _styles2.default.category.emojiContainer },
      (0, _map2.default)(emojis, function (emoji) {
        return _react2.default.createElement(
          'div',
          {
            key: 'emoji-' + emoji.shortname,
            onClick: function onClick(event) {
              return sendEmoji(event, emoji);
            },
            style: _getStyles2.default.categoryEmoji(emojiStyle),
            className: 'emoji'
          },
          (0, _htmlReactParser2.default)(_emojione2.default.toImage(emoji.shortname))
        );
      }),
      _react2.default.createElement('div', { style: _styles2.default.after })
    ),
    _react2.default.createElement(_radium.Style, {
      scopeSelector: '.emoji',
      rules: {
        '.emojione': {
          width: 'inherit',
          height: 'inherit',
          pointerEvents: 'none'
        }
      }
    })
  );
};

EmojiCategory.propTypes = propTypes;
EmojiCategory.defaultProps = defaultProps;

exports.default = (0, _radium2.default)(EmojiCategory);
module.exports = exports.default;